import type { PaginatedDocs } from '@nhanho/shared'
import { Button } from './Button'

export function Pagination<T>({ data, onPage }: { data: PaginatedDocs<T>; onPage: (p: number) => void }) {
  if (data.totalPages <= 1) return null
  return (
    <div className="flex items-center justify-between gap-3 text-sm text-ink-muted">
      <span>
        {data.pagingCounter}–{Math.min(data.pagingCounter + data.docs.length - 1, data.totalDocs)} / {data.totalDocs}
      </span>
      <div className="flex items-center gap-1.5">
        <Button variant="secondary" size="sm" disabled={!data.hasPrevPage} onClick={() => onPage(data.page - 1)}>← Trước</Button>
        <span className="px-2">Trang {data.page} / {data.totalPages}</span>
        <Button variant="secondary" size="sm" disabled={!data.hasNextPage} onClick={() => onPage(data.page + 1)}>Sau →</Button>
      </div>
    </div>
  )
}
